import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS, reaction } from "mobx";
import { observer, inject } from "mobx-react";

import mapUtils from "../methods";
import { isDesktop, jumpToTopHideHeader } from "../../../utils";
import { Utils } from "arv-reactcomponents";

import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

// const CURRENT_LOCATION_MARKERCOLOR = "#0182cb";
@inject("StoreListStore")
@observer
class StoreLocatorMap extends Component {
  static showBackButton() {
    return isDesktop ? "nwc-hide" : "";
  }
  constructor(props) {
    super(props);

    this.map = {};
    this.markers = null;

    this.getDirection = this.getDirection.bind(this);
    this.watchForStoresUpdate = this.watchForStoresUpdate.bind(this);
    this.showMarkers = this.showMarkers.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.onMarkerSelect = this.onMarkerSelect.bind(this);
    this.showMobileView = this.showMobileView.bind(this);
  }

  componentDidMount() {
    mapUtils.injectGoogeMapScript(document).then(() => {
      this.props.StoreListStore.initCurrentLocation().then(() => {
        if (isDesktop) {
          this.createMap();
        }
        this.watchForStoresUpdate();
      });
    });
  }

  onMarkerSelect(fcId) {
    Analytics.trackEvent({
      action: Event.action.MAP_STORE_CLICK,
      category: Event.category.STORE_LOCATOR,
    });
    this.props.StoreListStore.setSelectedStoreFCID(fcId);
    const storeListUl = document.getElementsByClassName("nw-store-list")[0];
    Utils.scrollElemToTop(
      storeListUl,
      storeListUl.getElementsByClassName(`nwc-store-${fcId}`)[0],
    );
  }

  getDirection() {
    mapUtils.getDirection(window.google, this.map);
  }

  showMobileView() {
    const storeListUl = document.getElementsByClassName(
      "nwc-storeform-container",
    )[0];
    storeListUl.style.paddingTop = "24px";
    this.props.StoreListStore.resetMobileView();
  }

  watchForStoresUpdate() {
    reaction(
      () => this.props.StoreListStore.storesList,
      list => {
        if (list.length) {
          if (Object.keys(this.map).length === 0) {
            this.createMap();
          }
          if (!isDesktop) {
            const storeListUl = document.getElementsByClassName(
              "nwc-storeform-container",
            )[0];
            storeListUl.style.paddingTop = "0";
          }
          this.clearMarkers();
          this.bounds = new window.google.maps.LatLngBounds();
          this.showMarkers(toJS(list));
          mapUtils.setMapCenter(this.map.getCenter());
          if (!isDesktop) {
            setTimeout(() => {
              this.map.fitBounds(this.bounds);
              jumpToTopHideHeader(); // need to write a generic method
            }, 500);
          }
        } else if (isDesktop) {
          Analytics.trackEvent({
            action: Event.action.ZERO_STORE,
            category: Event.category.STORE_LOCATOR,
            label: `${this.props.StoreListStore.brandName}, ${
              this.props.StoreListStore.currentPincode
            }`,
            interaction: false,
          });
          this.props.StoreListStore.initCurrentLocation().then(() => {
            if (Object.keys(this.map).length === 0) {
              this.createMap();
            }
            this.clearMarkers();
            this.bounds = new window.google.maps.LatLngBounds();
            mapUtils.setMapCenter(this.map.getCenter());
          });
        }
      },
    );

    reaction(
      () => this.props.StoreListStore.selectedStoreFCID,
      fcId => {
        this.map.setZoom(17);
        this.map.panTo(this.markers[fcId].position);
        Object.values(this.markers).forEach((marker, index) => {
          marker.setZIndex(window.google.maps.Marker.MAX_ZINDEX - index);
        });
        this.markers[fcId].setZIndex(window.google.maps.Marker.MAX_ZINDEX);
        mapUtils.selectSingleMarker(window.google, this.markers[fcId]);
      },
    );
  }

  createMap() {
    const coords = toJS(this.props.StoreListStore.currentLocationCoords);
    const map = mapUtils.createMap(window.google, this.mapContainer, coords);
    this.map = map;
    this.bounds = new window.google.maps.LatLngBounds();
    mapUtils.addExtendControlToMap(map, window.google.maps, () => {
      if (this.props.StoreListStore.brandName) {
        this.map.fitBounds(this.bounds);
      }
    });
  }

  currentLocationMarker(props) {
    return mapUtils.personMarker(window.google, this.map, props);
  }

  createMarker(props) {
    return mapUtils.circleMarker(window.google, this.map, props);
  }

  showMarkers(storesLatLngList) {
    storesLatLngList.forEach(
      ({ latitude, longitude, fcId, markerColor }, index) => {
        const position = { lat: latitude, lng: longitude };
        const marker = this.createMarker({
          position,
          markerColor,
          label: `${index + 1}`,
          zIndex: window.google.maps.Marker.MAX_ZINDEX - index + 1,
        });

        mapUtils.addClickListenerOnMarker(marker, this.onMarkerSelect);
        marker.set("fcId", fcId);
        // marker.setZIndex(window.google.maps.Marker.MAX_ZINDEX + index + 1);

        this.markers = {
          ...this.markers,
          [fcId]: marker,
        };
        this.bounds.extend(position);
      },
    );
    this.map.fitBounds(this.bounds);
  }

  clearMarkers() {
    if (this.markers !== null) {
      Object.values(this.markers).forEach(marker => {
        marker.setMap(null);
        marker = null; // eslint-disable-line no-param-reassign
      });
      this.markers = null;
    }
  }

  render() {
    return (
      <div className="nw-storelocatormap-container">
        <i
          className={`nwc-goback-to-store-form icomoon-arrow_left ${StoreLocatorMap.showBackButton()}`}
          onClick={() => this.showMobileView()}
          onKeyPress={() => this.showMobileView()}
          role="button"
          tabIndex="0"
        />
        <div
          className="nw-storelocatormap-container"
          ref={context => {
            this.mapContainer = context;
          }}
        >
          {/* Google Map Container */}
        </div>
      </div>
    );
  }
}

StoreLocatorMap.wrappedComponent.propTypes = {
  StoreListStore: PropTypes.shape({
    selectedStoreFCID: PropTypes.string,
    setSelectedStoreFCID: PropTypes.func,
    currentLocationCoords: PropTypes.object,
    storesList: PropTypes.object.isRequired,
    initCurrentLocation: PropTypes.func.isRequired,
    resetMobileView: PropTypes.func.isRequired,
    brandName: PropTypes.string,
    currentPincode: PropTypes.string,
  }).isRequired,
};

export default StoreLocatorMap;



// WEBPACK FOOTER //
// ./src/component/GoogleMap/StoreLocatorMap/index.js